import { ButtonProps, IconButton, SxProps } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const buttonContainer: SxProps = {
  color: 'customGrey.dark',
  ':hover': {
    backgroundColor: 'transparent'
  }
};

type Props = {
  direction: 'next' | 'previous';
} & ButtonProps;

export const DirectionButton: React.FC<Props> = (props) => {
  const { direction, ...restProps } = props;
  const iconProps: any = {
    fontSize: 'small'
  };

  return (
    <IconButton
      role={`${direction}-button`}
      sx={buttonContainer}
      {...restProps}
    >
      {direction === 'next' ? (
        <ArrowForwardIosIcon {...iconProps} />
      ) : (
        <ArrowBackIosNewIcon {...iconProps} />
      )}
    </IconButton>
  );
};
